import { render, staticRenderFns } from "./招商项目详情.vue?vue&type=template&id=ad7c7c3e&scoped=true"
import script from "./招商项目详情.vue?vue&type=script&lang=js"
export * from "./招商项目详情.vue?vue&type=script&lang=js"
import style0 from "./招商项目详情.vue?vue&type=style&index=0&id=ad7c7c3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7c7c3e",
  null
  
)

export default component.exports